export default "__VITE_ASSET__BeTT86wk__"